(function () {
  function initStickyAtc(bar) {
    if (bar.dataset.stickyAtcInit) return;
    bar.dataset.stickyAtcInit = '1';

    const sectionId = bar.dataset.sectionId;
    const realBtn = document.getElementById(`ProductSubmitButton-${sectionId}`);
    if (!realBtn) return;

    const proxyBtn = bar.querySelector('[data-atc-proxy]');

    // Find variant selector for scroll-to-variants behaviour
    const productInfo = document.getElementById(`ProductInfo-${sectionId}`);
    const variantSelector = productInfo?.querySelector('variant-radios, variant-selects');

    // Honour variant already selected via URL (e.g. links with ?variant=123)
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    let userSelectedVariant = !!urlVariant;
    if (variantSelector) {
      variantSelector.addEventListener('change', () => { userSelectedVariant = true; });
    }

    // sync disabled state + text from real button
    function syncState() {
      const isDisabled = realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
      proxyBtn.disabled = isDisabled;
      const realText = realBtn.querySelector('span')?.textContent?.trim();
      if (realText) {
        proxyBtn.textContent = realText;
        proxyBtn.setAttribute('aria-label', realText);
      }
    }
    syncState();

    new MutationObserver(syncState).observe(realBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
      subtree: true, // catches the inner <span> text too if needed
    });

    // Also observe the inner span for text changes (loading state)
    const realSpan = realBtn.querySelector('span');
    if (realSpan) {
      new MutationObserver(syncState).observe(realSpan, { childList: true, subtree: true });
    }

    proxyBtn.addEventListener('click', () => {
      if (variantSelector && !userSelectedVariant) {
        variantSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
        variantSelector.classList.add('sticky-atc-highlight');
        setTimeout(() => variantSelector.classList.remove('sticky-atc-highlight'), 1200);
        return;
      }
      if (!realBtn.disabled) realBtn.click();
    });

    new IntersectionObserver(
      ([entry]) => {
        const visible = entry.isIntersecting;
        bar.classList.toggle('is-visible', !visible);
        bar.setAttribute('aria-hidden', String(visible));
        proxyBtn.tabIndex = visible ? -1 : 0;
      },
      { threshold: 0 }
    ).observe(realBtn);
  }

  function initAll() {
    document.querySelectorAll('.sticky-atc-bar').forEach(initStickyAtc);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
